// import  Status from './Status'
export default {
  // component: Status,
  component: load(() => import(/* webpackChunkName: "Guardian-Status" */ './Status')),
  priority: 1,
  permissions: ['DeviceSituationsMenu'],
  name: app.translate('routes.home.guardian.Status'),
  icon: 'server-security',
  drawer: true,
};


